import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import { default as Old2005BlogPage, doNothingAnchor } from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—May 2006" />
	<Old2005BlogPage>
		<h2>May 2006</h2>





		<h3 className="blogdate">
		Tuesday, May 30, 2006
		</h3>






		<h4 className="blogitemtitle">
		My Xavier Rudd weekend
		</h4>





			<div className="blogitembody">
			I had the great fortune of seeing <em>Xavier Rudd</em> perform, with <em>Jeremy Fisher</em> opening, in Banff on Friday and in Calgary on Saturday. I am so very grateful to Kerri, Ming, and Andrea for providing me these opportunities! I am still very charged from this weekend, in fact it's a bit depressing now that it is over.<br /><br />[<em><b>All photos are courtesy of <a href="http://www.myspace.com/kylethekiwi">Kyle the Kiwi</a></b>. They are from the Saturday show at Mac Hall in Calgary. Also, Kyle does a mean Haka.</em>]<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/xavdrum.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />At this time I wish that I was a more profound writer - I know that my words here cannot possibly convey what I felt this past weekend. I am passionate about Xavier Rudd's music and messages, and these two shows far surpassed my expectations. Where do I begin?<br /><br />Ming and Andrea brought me to the Banff show on Friday night. Andrea's parents have a very accomodating condominium in Canmore, where we spent the night. We had a big breakfast of pancakes, eggs, bacon and strawberries for breakfast, then went for a walk along the Bow River before returning to Calgary. Then Kerri, Tara, Kyle, Heather and I danced it up for Xavier at <em>Mac Hall</em> on Sat night!<br /><br />Jeremy Fisher warmed the crowd at the <em>Eric Harvie Theatre</em>; wow is he great at this! He writes great songs, has a great voice, and a great sense of humor. At one point he asked the stage crew to find his mobile phone in his jacket pocket, backstage. He then called up a friend who wanted to hear <em>High School</em>, and talked with her casually for a bit while we waited (which was hilarious as he had just finished discussing how people have conversations on their phones in ridiculous places and situations), then gave his phone to a front-row audience member (with his friend on the line) while he performed the song! Jeremy also got the audience to sing an outro chorus on a great new song (can't recall the name), and finished his set with <em>Fall for Anything</em>, which I feel compelled to cover in the near future.<br /><br />I traded my CD (<em>Seventeen Oh-Two Oh-Six</em>) for Jeremy's <em>Back Porch Spirituals</em>, which I've listened to twice now - it's great! It holds a lot of great guitar and song style. He's super cool to meet, so don't be a stranger if you go see one of his shows! Now, on to Xavier...<br /><br />I don't know what to say about Xavier. Have you heard his recorded music? I love his style, his words, his messages, his spirit, his energy, all from simply hearing his recorded music over the past two years. His live show made my eyes leak - good tears, though, for happiness and for being in a wonderful moment. His voice was strong and clear. The sound system, from his stage mics to the PA system, were strong and crystal clear. His guitar playing was wicked. His rhythm was tribal, from his foot stomping to his amazingly percussive didj playing. Everything was beautiful.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/bigstage.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/abordidj.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/abordidjup.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/aborstory.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />Before playing, Xavier introduced an <em>Australian Aboriginal</em> friend, whose name I could not capture with my mind. This fellow was dressed in only a loin cloth. His black beard was as long, thick and curly as his hair, and he was caked in white mud. He introduced the didjeridu to the audience and explained how he made some common sounds. It was wicked!<br /><br />Xavier <em>dances</em> while playing percussive instrumental pieces, it is so cool to watch. Both his feet are stomping rhythms, his arms are drumming the bells, cymbals, and drums that he surrounds himself with, and his eyes are glazed forward while he blows amazing beats and sounds through a didj. During all of this, his shoulders are dancing with his arms - if he wasn't seated he'd dance right into the crowd, if only the instruments could continue without him! His rhythms are so tribal and infectious. All the theatre seats were empty for most of his show, we all had to stand, and only the stillest of rock-like people were not moving with him.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/xavlight.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/xavdarkred.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/flag&didj.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />If Xavier Rudd is performing somewhere near you, you MUST GO SEE HIM. It's an unforgettable experience. His Canadian fanbase has multiplied a ridiculous factor in the past year or two - his live show is getting very big (1000+ attendance). I couldn't see him in Australia, but I imagine his largest fan base is there... although I lived in some rural Aussie towns where people hadn't yet heard of him.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/stage.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/handshakes.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/blurpeace.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/xavbum.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			I'm hesitant to provide you with this link; although it is similar to the shows I saw this weekend, it simply fails to capture what I saw and felt at his shows. I guess that's how it often is between live and recorded music. However, you can go <a href="http://www.archive.org/details/xr2006-3-22.sbd.flac">here</a> to listen; <em>Chant</em> was one of my favorite moments in the shows. He also played a new song, the <em>Land Rights Song</em>, that I hope to hear again.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/xavblurthanks.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/xavblur.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			I can recommend this link to an <a href="http://www.archive.org/details/xrudd2004-05-17.flac">older show</a>, the recording quality is excellent and so is the energy. I love all of his recorded studio albums, <em>Food in the Belly</em> has really grown on me over the past four months, while <em>Solace</em> is my old favorite.<br /><br />Remember, a great way to give an artist your support is to buy their merchandise at their live shows. If you've had a wonderful experience, if you loved the music and the performance, if you feel charged, and you are thinking about buying a CD, a shirt, or a DVD... do it! Don't put it off and buy it from a store some other time. The artist receives more money when you purchase from them directly. It's economically similar to shopping at a farmer's market!<br /><br />At the Calgary show, Xavier was introduced by some <em>Canadian Aboriginal</em> leaders.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/chiefintro.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/endhugs.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/endbow.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />It will be a while before I see Kyle the Kiwi and Tara again, they are great people, they have been wonderful friends, and I will miss them!<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/ineedhaircut.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060529/friends.jpg"
			alt="Xavier Rudd in Banff and Calgary in 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />[<em><b>All photos are courtesy of <a href="http://www.myspace.com/kylethekiwi">Kyle the Kiwi</a></b>. They are from the Saturday show at Mac Hall in Calgary. Also, Kyle does a mean Haka.</em>]
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 3:18 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Final round of contest!
		</h4>





			<div className="blogitembody">
			I will be at <em>A Bar Named Sue</em> on Tuesday night (that's tomorrow) for the final round of their singer/songwriter contest!  The competition is cool, there are two guys (including me) and two girls.  Each style is relatively unique.  I believe the show starts at 21:00, and there is a cover of $3 (don't quote me on this figure).<br /><br />First prize is some money, as well as a recording opportunity on a compilation CD that the bar is producing.  Second prize is a <em>Sleeman</em>'s party at the bar (approximately 80 drink tickets on a <em>Sleeman</em>'s keg)!  I think it would be cool to win second prize, we could have a big party!  Yay!<br /><br />So, if you're feeling like a drink and hearing some musical variety for a couple hours... then come on down to the Sue Bar!<br /><br /><em>A Bar Named Sue</em> is at 1410 4th St. SW, Calgary.  Across from <em>The Sony Store</em>.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:16 AM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		The Holy Frying Pan
		</h4>





			<div className="blogitembody">
			The carbon steel frying pan is my favorite frying pan. So are black iron pans. Cast iron is great, but super heavy. Here's a quick bit about seasoning a carbon steel or black iron pan, if you'd like to stop buying non stick pans that wear out.<br /><br />I bought a carbon steel frying pan for $10 - $20, I can't remember exactly. I got it at an Asian restaurant supply store. I bought some bacon and fried a few rashers to render some fat, then discarded the rashers and the liquid fat. I wiped/scrubbed the pan with a rag and started again with another few rashers. This time I took the liquid fat and rubbed it all over the pan with a rag (light coating), then put the pan in the over for 4 hours at approximately 200 °C.<br /><br />Now I use the pan to fry eggs, potatoes, onions, meat, whatever. I don't clean the pan afterwards, I just put it away, it's ready for next time. I get the pan quite hot, add some good oil and watch it nearly smoke, then fry my fry-ables. Nothing sticks! Oh, perhaps you are afraid of oil. Then perhaps this won't work out for you, because you need hot oil in the pan for this to work. I like oil, I like a bit of fat, I am okay with it, I prefer it. My favorite fats include pork, olive, sunflower, peanut, any nut really, and avocado.<br /><br />I don't like non-stick pans. It irks me to know that the coating material, which was created in some scientist's lab, is slowly flaking off into the food. I also wonder if things are passing into the food at a molecular level. Perhaps steel or carbon molecules are passing into my food when I use my frying pan, but without researching much at all, I'll say that I prefer steel and carbon. And my frying pan will last a long time - those non-stick pans always seem to wear, regardless of how expensive they are.<br /><br />Related Links:<br /><a href="http://radio3.cbc.ca/blogs/2006/5/The-Curse-of-the-Non-Stick-Pan">CBC Radio 3 blog</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:04 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Monday, May 22, 2006
		</h3>






		<h4 className="blogitemtitle">
		Almond milk is tits
		</h4>





			<div className="blogitembody">
			Almond milk:  20 plain, raw almonds with skin, blended in a super-duper blender with 250 - 500 ml of water.  Add one really really good date for sweetener, if you want.<br /><br />Thanks to my Oma for showing me this little trick when I was a wee one!<br /><br />I used to call this a <em>nut shake</em> when I was impressing new girlfriends.  If the new girlfriend liked it, then I liked her!  Ha ha.<br /><br />Seriously, blend this up, it sounds gross but if you blend it very well, you get a delicious frothy milk.  You can apply this milk to your musli!  I'm thinking of using it to make poppy seed cake, too.  Adding the date for sweetener is the best, because good quality dates are so sweet and sticky - a great addition to this simple drink!<br /><br />If you think I'm nuts, is it perhaps possible that you have not tried a <em>nut shake</em>?  If you've been reading my other journal entries, you might consider that I have tried adding melted, pure chocolate to this mix... and yes, you might even consider that it is friggin' good.<br /><br />Related Links:<br /><a href="http://en.wikipedia.org/wiki/Almond_milk">Wikipedia on almond milk</a><br /><a href="http://en.wikipedia.org/wiki/Date_Palm">Wikipedia on dates</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:59 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Peanut chocolate honey fudge
		</h4>





			<div className="blogitembody">
			Remember how I was writing silly about chocolate and honey fudge? Well, you can add peanut butter. It's great! It's delicious!<br /><br />I choose pure peanut butter, you know, the kind with <em>peanuts</em> as the sole ingredient (what a novel idea). Stir it up nice and good so that the oil and peauts mix well, then put a tablespoon of it into your chocolate and honey! Proceed as I outlined in my previous post (see below for link)!<br /><br />Damn, it is good. Pure chocolate, pure unpasteurized honey, and pure peanut butter!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:50 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Campfire party in Kananaskis
		</h4>





			<div className="blogitembody">
			Thanks so much to Brooke, Corynn, and Fun Drunk Laura for hooking me up with a great night in Etherington (Kananaskis)!<br /><br />It's currently May long weekend in Canada, the big Victoria Day weekend.  This is the weekend that everyone goes camping!  I can't afford to go camping these days, so I didn't plan anything.  I was just gonna hang out here in Kensington/Sunnyside and chill, play music, and work.<br /><br />Brooke suggested that I come to Etherington just for Friday night, as she and Cherine would return to Calgary on Saturday evening (Danny Michel performance).  I didn't have to worry about fuel money, camping fees, or tent space!  I had plenty of free Guinness from work, so it was meant to be!  I brought some bananas, almonds, and rye bread for food and all was well!<br /><br />Corynn and Laura picked me up after work on Friday and we three drove to Etherington.  What a blast!  There were 30 to 40 people around a big fire, and lots of musicians!  Fitz was playing guitar and mandolin, and lots of cool original songs that are great for campfires.  There was also a banjo, several djembe drums, more guitars, more mandolins... a cornicopia of music and musicians!<br /><br />Lots of Newfies were in the crowd, too, which is totally fun!  People from Newfoundland are fun.  That's all I shall say about them!<br /><br />We played loud and late into the night, we even attracted people from distant camping spots down the road.  Some visiting dude was having himself a mushroom trip, and he was in love with my hair.  He even tried to play with it. He also loved my guitar playing, but I can't recall which he loved more.  I was a bit zipped myself, but I think Cherine will back me when I say I was averse to his affection.  (Elbow nudge into Cherine's ribs). He later performed a strange candle ceremony for Corynn's birthday.<br /><br />I was super concerned about lasting past midnight before passing out, but Brooke assured me that I lasted till 2 am, so that makes me happy.  Brooke watched the sunrise, however.  What a trooper!<br /><br />I was sad to return to Calgary, as Kananaskis is so tits!  But I am so grateful for the opportunity to camp and party in the mountains for the night, and I hope that everyone is enjoying their last night there!<br /><br />Related Links:<br /><a href="http://www.kananaskis.com/">Never heard of Kananaskis?</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:15 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Thursday, May 18, 2006
		</h3>






		<h4 className="blogitemtitle">
		Play it forward
		</h4>





			<div className="blogitembody">
			On Monday evening I met Danny and Pierce at <em>Riley Park</em>; we sat in the late sun and I played songs with my guitar.  They planted the <em>Play it Forward</em> seed in my head, and an idea has grown.<br /><br />Monday I sat outside all day.  It was great!  The sun was free in the sky the entire day, and I sunburned for the first time since returning to Canada!  I was reading <em>Fast Food Nation</em> on a bench on a hill, overlooking <em>Sunnyside</em>, <em>Kensington</em>, and downtown <em>Calgary</em>, while viewing the <em>Rocky Mountains</em> in the clear distance.<br /><br />After dinner I took my guitar to <em>Riley Park</em> and played, alone on a bench. Soon Danny and Pierce joined me and chilled in the grass, listening.  Danny thought to give me an illegitimate copy of <em>Calexico</em>'s CD, <em>Feasts of Wire</em> - he figured I might like some of the music. I'm not an advocate of illegitimate copies, but I took the CD.  We all agreed that I should pass the CD onwards, so that someone else could hear it.<br /><br />Danny and Pierce spoke of the <em>Play it Forward</em> concept, where you listen to the CD and then pass it onwards for the next person to hear it.  We wanted to implement this process with the <em>Calexico</em> CD, but we chose not to since it is an illegitimate copy.<br /><br />I decided to initiate <em>Play it Forward</em> with my CD, <em>Seventeen Oh-Two Oh-Six</em>, and Danny has agreed to be the first participant!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:49 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Hard work finally pays off
		</h4>





			<div className="blogitembody">
			I've been working at a liquor store during my stay in Calgary, to earn my rent and food. Today I received free beer, because I'm a nice guy! I was given 19 cans of Guinness and 5 cans of Dab! The beer cans were not fit for retail, but the beer inside the cans is very fit for drinking.<br /><br />I chose this job at the liquor store because I needed simple work, and because I am only available for 20 hours per week, during the weekdays. I am partly responsible for stocking the shelves with the liquor, wine and beer that arrives several times per week. It's great excercise!<br /><br />The management has been very respectful and accomodating of me and my musical life, and I consider this gift of beer a very nice gesture!<br /><br />I love Guinness!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:46 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		This time, I may need your vote
		</h4>





			<div className="blogitembody">
			I've been invited to the next round of the singer/songwriter contest at <em>A Bar Named Sue</em>.  I'll be showing up at around <em>21:00 on May 23, 2006</em>.  I don't know exactly when my turn on the stage will come, but I will play four songs.<br /><br />Last time the crowd and judges voted me into this upcoming round.  However, this time there are no judges - only the crowd is voting! So if you have nothing to do, come on down and hear the songs from the songwriters, and place your vote!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:30 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Martin Sexton sings like a trumpet
		</h4>





			<div className="blogitembody">
			Have you heard this man sing yet? He's quite good, but you'll discover that he's quite amazing if you listen to <em>13 Step Boogie</em> from his CD <em>Live Wide Open</em>... that's not a trumpet that you will hear! It's the voice of <em>Martin Sexton</em>. Amazing!<br /><br />I just joined his mailing list (from his website) so that I might have a chance of seeing him perform live in the future.<br /><br />Link: <a href="http://www.martinsexton.com">http://www.martinsexton.com</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:15 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Wednesday, May 10, 2006
		</h3>






		<h4 className="blogitemtitle">
		Seventeen Oh-Two Oh-Six available online
		</h4>





			<div className="blogitembody">
			My CD <strong><em>Seventeen Oh-Two Oh-Six</em> is now available online for purchase</strong> through <em>CDBaby</em>.  A shopping cart is now positioned conveniently at the front of my website!<br /><br />If you want a copy of my CD, I will almost always prefer you to <strong>buy it from me, in person</strong>.  I will feel better personally handing you my CD... also, I profit more from personally selling my CD!  Ultimately, I think <em>CDBaby</em> is providing a great service, and I invite you to use it, especially if you cannot meet me in person!<br /><br /><em>CDBaby</em> has created a webpage dedicated to my CD, <a href="http://www.cdbaby.com/cd/rivest/">click here</a>.  At this page you may listen to audio samples of my songs, as well as read or post reviews for my CD.  I invite you, if you've listened to it, to <strong>post your own review of my CD</strong>!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 12:03 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		CD celebration a success!!
		</h4>





			<div className="blogitembody">
			My <em>CD Celebration</em> was a huge success last night at <em>Karma Local Arts House</em>, in Calgary!<br /><br />All the seats were filled with new and old friends, and candles on the tables and the bar set an atmosphere for listening.  I was elated with the support I received after each song's delivery, and from the comments and compliments I received afterwards.  I saw a lot of smiles in an audience of friends!<br /><br />Gigs like last night's are sparse for unknown, indie musicians - only with a house full of friends and friends-of-friends can we easily achieve such a quality and quantity of audience-performer connections.  I am grateful for the fun time!<br /><br />I was happy to give the stage to musical friends <em>Brooke Wiley</em>, <em>Dave Simpson</em>, <em>Allan Pusey</em>, and <em>Tynan and Shelly Groves</em>, as well as new acquaintance <em>Billy Mandziuk</em>!  They all sounded fantastic, performing while I visited with as many people as I could - I felt a little "spread thin."  I wish I could have spent more time with everyone individually!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 11:29 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Sunday, May 07, 2006
		</h3>






		<h4 className="blogitemtitle">
		I didn't get lei-d, those are scarves
		</h4>





			<div className="blogitembody">
			Thanks to <em>Kyle the Kiwi</em> for giving me these pics! He's a bit of a photographer, I don't know if you knew that.  I don't know if you know <em>him</em>!<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060506/kyleblur.jpg"
			alt="Jesse Rivest playing guitar"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={402}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060506/kylesharp.jpg"
			alt="Jesse Rivest playing guitar"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={402}
			/>
			<br /><br />I was visiting <em>Kyle the Kiwi</em> and <em>Tara</em> one night this past winter, when Tara offered me her guitar for a song.  I believe I was playing <em>Broken Heart</em> by <em>Lester Quitzau</em>.  Hence the solemn face!<br /><br />They had these colorful scarves that I simply had to wear!  We were drinking <em>Kokanee</em>, which is known to be conducive to silliness.<br /><br />I think we should bug <a href="http://www.myspace.com/kylethekiwi">Kyle the Kiwi</a> to start a photo blog... he has pics that are much more interesting than these of me!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 11:39 AM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Web Syndication: get with it
		</h4>





			<div className="blogitembody">
			Here's a little bit on <em>web syndication</em> and how I am involving it in my website. Read further as you may be interested in this topic!<br /><br />First, here's <em>wikipedia</em>'s definition for <a href="http://en.wikipedia.org/wiki/Web_syndication">web syndication</a>. It's not a new concept, but it is new to me.<br /><br />I want to make it easier for you to stay up-to-date with my doings. You know I play music, you know I travel, and you may know I have a variety of interesting interests! I update my website on these topics, and I share my website with you.<br /><br /><strong>Problem: <em>you may not remember to visit my website regularly!</em></strong><br />(or you may not be interested in doing so, and that's okay!)<br /><br />In November, 2005, I started a mailing list. This was my first solution to the problem. Since then I have learned of some more solutions. The following are ways for you to be notified of my news and updates.<br /><br /><ol><li><strong>Join my email mailing list</strong>. The updates are infrequent and personal, and focused on my musical life. I've sent approximately 5 emails since November, 2005.<br /><p><a href="/" onClick={doNothingAnchor}>follow this link to join my mailing list</a></p></li><li><strong>Subscribe to receive email notifications when I post new journal entries.</strong> You will only receive one email per day, and only on days that I post new entries. I post at least one entry per month, and as many as ten per month! <em>(This is a service external to my website, unlike my mailing list which I control)</em><br /><br /></li><li><strong>Add my <em>site feed</em> to a feed reader.</strong> I started experimenting with <em>Google Reader</em>, a place on the web where you can consolidate all the news you are interested in. Clicking on the <em>Add to Google</em> button will add my site feed to <em>Google Reader</em> for you. <p><a href="/" onClick={doNothingAnchor}>(removed)</a><br /><br /><em>Or follow <a href="/" onClick={doNothingAnchor}>this link</a> to see more feed readers.</em></p></li><li><strong>Add my site feed to your personalized Google home page!</strong> This is my latest favorite. I use <em>Google</em> for my web searching, and now I see the following on my personalized search page: weather in Australia and Canada, <em>CBC News</em>, <em>ABC News</em>, <em>Radio New Zealand News</em>, <em>Reuters News</em>, and updates from my friends' websites (which also publish site feeds).</li></ol>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:30 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Friday, May 05, 2006
		</h3>






		<h4 className="blogitemtitle">
		I am hungry for a jaffel
		</h4>





			<div className="blogitembody">
			I had a last-minute invite tonight for an escape to <em>Bragg Creek</em>, where we would have a campfire and cook jaffels for dinner. It didn't take long to convince myself that I could take a break from my ongoing work! Alas, the invitation was cancelled and I felt a bit crestfallen.<br /><br />I was flooded with memories from Australia. Jess introduced me to toastie-toasties (jaffels) with ham, tomato, cheese, and baked beans inside! Before I met her in <em>Coral Bay</em>, I had never heard of jaffels before - Cormac had a jaffel iron amongst his camping gear in Julia (his green Mistibushi Pajero) the entire time and never busted it out!<br /><br />A jaffel is a bread-pie that you can make over coals or in an open fire. A jaffel iron is two indented squares of cast iron such that, when you press them together, an inner pocket is created. Butter one side each of two slices of bread. Place one slice into the bottom side of the jaffel iron, butter against iron. Place your toppings on top of that slice, and be generous! Put the second slice of bread on top, butter up, and bring the top side of the iron down, closing the jaffel iron. Cook. A perfectly cooked jaffel will not be burnt - the outer bread shell will be golden brown, and the insides will be hot (cheese melted)! Enjoy!!!!<br /><br />I remember Cormac, Kell, Jess and I caravanseraid from <em>Exmouth</em> to <em>Tom Price</em> one day, we didn't quite make it and pulled off the road to camp at dusk.  It was a long, warm day of driving; Cormac had to fill Julia with petrol from the reserve fuel cans (there's no roadhouses), and Jess accidentally killed a bird with her car.  We found a grove of trees sticking out of the dry, red earth and built a campfire.  Jess made jaffels with canned chilli, I think, and we slept on the ground, next to the fire and under the stars.  We saw a UFO that night, it was unlike anything I had seen before.  In the morning I remember being drawn to a particular bird that sounded like rattling wood, I wish I could recall it's sound or appearance now.<br /><br />Just a bit north of Port Hedland, we camped at a 24 hour rest spot, on a river (can't recall the name).  We were far enough north for saltwater crocodiles to be a mild concern (or not, depends who you talk to) - Jess slept in her car, I slept in a front seat of the Pajero, and Kell and Cormac braved it sleeping under a mosquito net hung from a huge eucalypt!  We first had jaffels for dinner, over a small fire between our vehicles.  When we woke in the morning, we had breakfast jaffels!<br /><br />My favorite jaffel: crunchy, natural peanut butter, sliced banana, and honey. Substitute jam for honey if you like, but honey is the tits!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 11:22 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Wednesday, May 03, 2006
		</h3>






		<h4 className="blogitemtitle">
		Connecting - one person at a time
		</h4>





			<div className="blogitembody">
			Tonight I attended a <em>round one</em> session of a songwriter contest at <em>A Bar Named Sue</em>.  At the end of the evening, a vote was held to see which two songwriters would advance to the next round - three judges' votes were given half weight, while the crowd's votes were given the other half weight.  A lady named M. J. and myself were selected to proceed to the next round!<br /><br />It's now May 3, early morning, and I am ready to go to sleep.  I was about to write "today was a great day", but what I mean is "yesterday was a great day!"  Yesterday was a great day - I connected with Judith, a recent acquaintance, over coffee.  I felt we got along very well, it was great to talk with her, and I plan to do so again!  She quit her job to take a small vacation to Jasper with a friend from Quebec.  I love that about her.<br /><br />At the <em>Sue Bar</em>, after our song sets, I connected with singer/songwriter Billy.  I think Billy and I got along tonight because he is in a place where he is not quite following his heart.  He realizes it, and it excited me to talk with him in this state.  I have been there before.  I may be there again.  Billy had been to Australia, New Zealand, and Indonesia - years ago - and feels his heart aching to be on the road again, playing more music, and finding happiness from simple things.  I could relate to him.  I have a feeling I'll be seeing Billy again in the near future.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:34 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Monday, May 01, 2006
		</h3>






		<h4 className="blogitemtitle">
		CD Celebration announcement
		</h4>





			<div className="blogitembody">
			I'm having a <strong>CD Celebration</strong> at <em>Karma Local Arts House</em>, Calgary, Alberta, on May 8. The show starts at <strong>21:00</strong> and admission is free! I've invited <em>Tynan and Shelly Groves</em>, <em>Brooke Wylie</em>, <em>Allan Pusey</em>, and <em>Dave Simpson</em> to play some music, too! I hope to see you there!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:00 PM &nbsp;
			</div>






		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
